module.exports = __webpack_public_path__ + "static/media/CARAOKE.fc6811ff.png";